import { ATS_CAREER_SITE_ADMIN_SHARED } from './constants';

export const es = {
  [ATS_CAREER_SITE_ADMIN_SHARED]: {
    RECRUITMENT: 'Reclutamiento',
    CAREER_SITE: 'Portal de empleo',
    SUBTITLE_CAREER_SITE:
      'Configura y personaliza tu portal de empleo para mostrar tus vacantes y atraer a los mejores candidatos.',
    BANNER_TOP_TEXT:
      'Las ofertas de empleo son demostrativas y sirven únicamente para que te hagas una idea de la apariencia del portal.',
    VACANCY: 'Vacante',
    DEPARTMENT: 'Departamento',
    POSITION: 'Posición',
    CLOSED_DATE: 'Fecha de cierre',
    PUBLISHED_DATE: 'Publicado hace {{days}}',
    SEARCH_BY_NAME: 'Buscar por nombre',
    DAY: 'día',
    MONTH: 'mes',
    YEAR: 'año',
    DAYS: 'días',
    MONTHS: 'meses',
    YEARS: 'años',
    CLOSED_DATE_CARD: 'Fecha de cierre: {{date}}',
    FILTER_BY: 'Filtrar por',
    SEARCH_BY_DEPARTMENT: 'Buscar por departamento',
    NO_DEPARTMENTS_FOUND: 'No se encontraron departamentos',
    TRY_ANOTHER_SEARCH: 'Intenta otra búsqueda',
    VACANCY_EXAMPLE: 'Vacante de ejemplo',
    OPEN_DATE_EXAMPLE: 'Publicado hace 3 días',
    DEPARTMENT_EXAMPLE: 'departamento',
    FAILED_TO_EXTRACT_JOB_ID_FROM_VACANCY_LINK:
      'No se pudo redirigir al formulario de postulación',
    VACANCY_LINK_IS_EMPTY: 'No se pudo redirigir al formulario de postulación',
  },
};
